import cubejs, { LoadMethodOptions, Query } from '@cubejs-client/core';
import { ICubeRepository } from '../interface/cube-repository.interface';
import { QueryErrorMessages } from '../enum/cube-error-message.enum';
import { ILogManager } from '../interface/log.manager.interface';
import { LogManager } from '../helpers/log/log.manager';

export type PaginatedResult<M> = {
  rows: M[];
  hasNextPage?: boolean;
  nextToken?: number;
};

export class CubeRepository implements ICubeRepository {
  endpoint: string;
  logManager: ILogManager;
  constructor(deps: { endpoint: string; debug: boolean }) {
    this.logManager = new LogManager({ debug: deps.debug });
    this.logManager.debug('Initializing with config:', deps);
    this.endpoint = deps.endpoint;
    this.logManager.debug('Client initialized');
  }

  /**
   * Generic cube api wrapper method. For use in Domain repositories only.
   * @param token {string} CUBE API Token
   * @param data {Cube.Query} CUBE Query object
   * @param options? {Cube.LoadMethodOptions} Optional CUBE Query method options object
   * @returns Cube api response
   */
  async query(
    token: string,
    data: Query,
    options?: LoadMethodOptions
  ): Promise<any[]> {
    try {
      const client = cubejs(token, {
        apiUrl: this.endpoint,
      });
      this.logManager.debug(
        'calling api with data',
        JSON.stringify(data, null, 4)
      );
      const response = await client.load(data, options);
      this.logManager.debug('response', response.rawData());
      return response.rawData();
    } catch (error) {
      this.logManager.debug('Caught error in query', error);
      throw new Error(`${QueryErrorMessages.ApiCallError}: ${error}`);
    }
  }
}
